/** InsCoder WANG.J 2026-06-22 B + Cart page GWP progress bar custom element **/
class CartPageProgressBar extends HTMLElement {
  constructor() {
    super();
    this.renderCartPageProgressBar();
  }

  renderCartPageProgressBar() {
    if (!window.progressBar) return;

    const hasMeter = Boolean(this.querySelector('.price-progress-bar .meter'));
    if (hasMeter) {
      window.progressBar(this);
      return;
    }

    fetch('?section_id=helper-cart-progress-bar')
      .then((response) => response.text())
      .then((text) => {
        const innerHTML = new DOMParser()
          .parseFromString(text, 'text/html')
          .querySelector('[data-js-cart-progress-bar]');

        if (innerHTML) {
          this.innerHTML = innerHTML.innerHTML;
          window.progressBar(this);
        }
      });
  }
}

if (typeof customElements.get('cart-page-progress-bar') === 'undefined') {
  customElements.define('cart-page-progress-bar', CartPageProgressBar);
}
/** InsCoder WANG.J 2026-06-22 E + Cart page GWP progress bar custom element **/
